/**
 * Display helper for actor/creator identities. Legacy rows stored the literal
 * "desconocido" (AdminActorIdentity fallback) because Entra v2 tokens lacked
 * `upn`; those are not recoverable, so the panel shows "Sin registrar".
 */
export const UNREGISTERED_ACTOR_LABEL = "Sin registrar";

export function formatActor(value: string | null | undefined): string {
  const trimmed = value?.trim() ?? "";
  if (trimmed === "" || trimmed.toLowerCase() === "desconocido") {
    return UNREGISTERED_ACTOR_LABEL;
  }
  return trimmed;
}
